import * as React from "react";

const HubspotCTAComp = ({
  embedCode,
}: {
  embedCode: { embedCode: string };
}) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (window) {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {!loading && (
        <div dangerouslySetInnerHTML={{ __html: embedCode.embedCode }} />
      )}
    </>
  );
};

export default HubspotCTAComp;
